// Tracks whether each org has an OpenRouter key configured, based
// on what the balance poll learned most recently. Spend helpers
// short-circuit when we know no key exists so the browser console
// doesn't auto-log the backend's 428, and the user sees a clean
// client-side warning instead.
//
// `null` / not-yet-set = unknown; first spend attempt falls through
// to the backend and surfaces whatever it returns. Once the balance
// chip polls, subsequent attempts are decided client-side.

const configured = new Map<number, boolean>();
const EVENT = "wt:or-key-status-change";

export function setKeyConfigured(orgId: number, isConfigured: boolean): void {
  const prev = configured.get(orgId);
  configured.set(orgId, isConfigured);
  if (prev !== isConfigured && typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent(EVENT, { detail: { orgId, configured: isConfigured } }),
    );
  }
}

/** null when we haven't checked yet; boolean once the balance chip
 * or a direct lookup has reported back. */
export function isKeyConfigured(
  orgId: number | null | undefined,
): boolean | null {
  if (orgId == null) return null;
  return configured.has(orgId) ? (configured.get(orgId) ?? null) : null;
}

export function onKeyStatusChange(cb: () => void): () => void {
  if (typeof window === "undefined") return () => {};
  const handler = () => cb();
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
